import i18next from 'i18next';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
  newPasswordCopy: Yup.string().oneOf([Yup.ref('newPassword')], i18next.t('validation.passwordsMustMatch')),
});
